import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HistoriquesComponent } from './historiques.component';
import { HistoriquesViewComponent } from './historiques-view/historiques-view.component';

const routes: Routes = [
  { path: '', component: HistoriquesComponent },
  { path: 'view/:id', component: HistoriquesViewComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HistoriquesRoutingModule { }
